export default __webpack_public_path__ + "static/media/cw.e95152b9.svg";